export default __webpack_public_path__ + "static/media/alumini (1).ab1580bf.jpg";